(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 73700:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(64167);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5447);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27427);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);



var Input = function(_param) {
    var children = _param.children, labelClass = _param.labelClass, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "labelClass"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: labelClass,
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 64167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(43692);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44453);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8014);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62044);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46323);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6054);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _context_authContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13102);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17651);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99731);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75332);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3245);
/* harmony import */ var _enums_errors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10367);
/* harmony import */ var _components_Input__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(84019);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(28808);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70082);
/* harmony import */ var _components_LoadingComponent__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(63104);


















var Login = function(param) {
    var history = param.history, countryCode = param.countryCode;
    var auth = (0,_context_authContext__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .aC)();
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_8__/* .Namespace.Login */ .l.Login).t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var serverError = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_14__/* .useLang */ .J)().locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), setNotVerified = ref1[1];
    var RULE_PASSWORD = t("common:form.password_min_chars");
    var RULE_NOT_EMPTY = t("common:form.not_empty");
    var RULE_WRONG_EMAIL = t("common:form.email_format");
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (auth.isUserLoaded && auth.user) {
            router.push(_helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.collection */ .xm.collection(locale));
        }
    }, [
        auth.user,
        auth.isUserLoaded
    ]);
    var onSubmit = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
            var formSchema, form, email, password, validateObject, valid, resp, redirectRoute;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .setLoadingState */ .bG)(ref.current);
                        formSchema = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .createFormSchema */ .ZS)({
                            email: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .emailRule */ .$D)(RULE_WRONG_EMAIL, RULE_NOT_EMPTY),
                            password: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .passwordRule */ .nk)(RULE_PASSWORD, RULE_NOT_EMPTY)
                        });
                        form = event.target;
                        email = form.email.value;
                        password = form.password.value;
                        validateObject = {
                            email: email,
                            password: password
                        };
                        valid = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .validateForm */ .G$)(formSchema, validateObject, ref.current);
                        if (!valid) {
                            _ctx.next = 33;
                            break;
                        }
                        _ctx.prev = 10;
                        setNotVerified(false);
                        _ctx.next = 14;
                        return auth.signin(email, password);
                    case 14:
                        resp = _ctx.sent;
                        if (resp.emailVerified) {
                            _ctx.next = 19;
                            break;
                        }
                        {
                            serverError.current.innerHTML = t("not_activated");
                            ref.current.classList.add("display-server-errors");
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(ref.current);
                            setNotVerified(true);
                        }
                        _ctx.next = 25;
                        break;
                    case 19:
                        if (!(history.length > 0)) {
                            _ctx.next = 24;
                            break;
                        }
                        redirectRoute = history.find(function(route) {
                            return route !== _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.login */ .xm.login(locale);
                        });
                        if (!redirectRoute) {
                            _ctx.next = 24;
                            break;
                        }
                        router.replace(redirectRoute);
                        return _ctx.abrupt("return");
                    case 24:
                        router.push(_helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.collection */ .xm.collection(locale));
                    case 25:
                        _ctx.next = 31;
                        break;
                    case 27:
                        _ctx.prev = 27;
                        _ctx.t0 = _ctx["catch"](10);
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(ref.current);
                        if (_enums_errors__WEBPACK_IMPORTED_MODULE_11__/* .LoginErrorType.WrongPassword */ .b.WrongPassword === _ctx.t0.code || _enums_errors__WEBPACK_IMPORTED_MODULE_11__/* .LoginErrorType.UserNotFound */ .b.UserNotFound === _ctx.t0.code) {
                            serverError.current.innerHTML = t("common:form.wrong_credentials");
                            ref.current.classList.add("display-server-errors");
                        }
                    case 31:
                        _ctx.next = 34;
                        break;
                    case 33:
                        {
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(ref.current);
                        }
                    case 34:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    10,
                    27
                ]
            ]);
        }));
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        auth
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_13__/* .basicSEO */ .F)(t("seo:login_title"), t("seo:login_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("main", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().login),
                children: auth.isUserLoaded && auth.isAnonymous ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().loginWrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                children: t("login")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    t("not_register_yet"),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        href: _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.registerStep1 */ .xm.registerStep1(locale),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                            children: t((0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getNoTrialTranslationKeyIfNeeded */ .jU)("try_trial", countryCode))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                ref: ref,
                                onSubmit: onSubmit,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Input__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        type: "text",
                                        name: "email",
                                        children: t("email")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Input__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        type: "password",
                                        name: "password",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                            className: "d-flex flex-row justify-content-between",
                                            children: [
                                                t("password"),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    href: _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.forgottenPassword */ .xm.forgottenPassword(locale),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        tabIndex: -1,
                                                        children: t("forgotten_password")
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                        type: "submit",
                                        className: "btn btn-primary",
                                        children: t("login_btn")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                        ref: serverError,
                                        className: "server-error",
                                        id: "server-error",
                                        htmlFor: "email"
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_LoadingComponent__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    spinnerSize: "medium"
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Login);


/***/ }),

/***/ 6054:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__nnXkC","loginWrapper":"login_loginWrapper__RKEmS"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(73700); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);